export const IsNullOrEmptyOrUndefined = value =>
  value === null || value === '' || value === undefined || value === 'null' || value === 'undefined';